
  import { mapState, mapGetters } from 'vuex'
  import bannerRedirect from '~/mixins/common/banner-redirect'
  import errorCodeStrings from '~/mixins/common/error-code-strings'
  import baseLogic from '~/mixins/base-logic'
  import ServerSide from '~/mixins/serverSide'
  import Meta from '~/mixins/meta'
  import InitPixel from '~/mixins/initPixel'
  import { globalVar } from '~/utils/globalVar'

  export default {
    name: 'Theme3',
    mixins: [baseLogic, ServerSide, bannerRedirect, Meta, errorCodeStrings, InitPixel],
    data() {
      return {
        isMobileScreen: false,
        // registerModal: false,
        country_code: 'LA',
        globalVar
      }
    },
    computed: {
      ...mapGetters({
        headerLogo: 'cms/headerLogo'
      }),
      ...mapState({
        menubars: state => state.cms.menus.menus,
        cms: state => state.cms.cms,
        isLogin: state => state.settings.isLogin,
        showHoldBalance: state => state.sockets.showHoldBalance,
        displayGetBonusDetail: state => state.sockets.displayGetBonusDetail,
        displayGetBonusModalState: state => state.sockets.displayGetBonusModal,
        withdrawalStatus: state => state.sockets.withdrawalStatus,
        displayWithdrawalSocketState: state => state.sockets.displayWithdrawalSocket,
        errorStrings: state => state.themes['language-string'].errorStrings
      }),
      navbarName() {
        if (this.isMobileOnly()) {
          return 'Theme3MobileNavBar'
        }
        return 'Theme3DesktopNavBar'
      },
      displayGetBonusModal: {
        get() {
          return this.displayGetBonusModalState
        },
        set(value) {
          this.$store.commit('sockets/setDisplayGetBonusModal', value)
        }
      },
      displayWithdrawalSocket: {
        get() {
          return this.displayWithdrawalSocketState
        },
        set(value) {
          this.$store.commit('sockets/setDisplayWithdrawalSocket', value)
        }
      }
    },
    watch: {
      $route(to, from) {
        if (!this.$cookie.get('visit') && !this.isInternational)
          this.$store.dispatch('themes/settings/fetchVisitWebsite')
      }
    },
    created() {
      if (process.client) {
        try {
          // eslint-disable-next-line nuxt/no-globals-in-created
          this.$cookie.set('previous_url', document.referrer)
        } catch (error) {}
      }
    },
    async mounted() {
      // To prevent multiple iframes on the website, Issue: https://techcsl.atlassian.net/browse/CSCSL-891
      if (window.top !== window.self) {
        window.top.location.href = '/'
      }

      this.$store?.dispatch('app/checkIsApp')

      // Fetch error code
      await this.getErrorCodeStrings()

      this.showBanner()

      // Get invite and earn domain link (refer-friend page)
      this.$store.dispatch('player/getPlayerInviteAndEarnDomain')
      this.getFaviconIcon()
      if (document.referrer) {
        this.$cookie.set('previous_url', document.referrer)
      }
      if (this.$cookie?.get('is_change_language')) {
        this.$store.commit('settings/changeLanguageLoading', true)
      }
      if (this.handleCookie('wl_locale')) {
        this.$recaptcha.language = this.handleCookie('wl_locale')
      }

      // Fetch visit API to get the banner ID
      this.$store.dispatch('themes/settings/fetchVisitWebsite')
      this.$store.dispatch('themes/settings/markAssociatedPlayer')
      if (!window?.sessionStorage?.getItem('visit') && !this.isInternational) {
        this.$store.dispatch('themes/settings/fetchVisitWebsite')
        window.sessionStorage?.setItem('visit', 'true')
      }

      if (this.isMobileOnly()) {
        this.$store.dispatch('cms/cmsComponentCode', {
          component_code: 'LiveChat',
          platform: 1
        })
      } else {
        this.$store.dispatch('cms/cmsComponentCode', {
          component_code: 'LiveChat',
          platform: 2
        })
      }

      if (this.menubars.length <= 0) this.$store.dispatch('cms/menus/getMenubars')
      // Call this store action only when the user is not on the home page and mobile device
      if (this.$route.path !== '/' && !this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 1,
          component_code: 'DesktopBackground'
        })
      // Call this store action only when the user is not on the home page but on mobile device
      if (this.$route.path !== '/' && this.isMobileOnly())
        this.$store.dispatch('cms/cmsComponentCode', {
          platform: 2,
          component_code: 'MobileBackground'
        })
      // if (this.cms.length <= 0) this.$store.dispatch('cms/cms', {})
      this.$store.dispatch('settings/supportCountryAndLanguage')
      this.$store.dispatch('themes/settings/getExchangeRate')

      // If the website is agent website, display agent floating icons
      this.$store.dispatch('cms/floatingIcons')
      const cookieCountryCode = this.$cookie?.get('country_code')

      if (this.isInternational) {
        this.country_code =
          cookieCountryCode === 'GO' ? this?.$cookie?.get('global_reg') : cookieCountryCode
      } else {
        this.country_code = 'LA'
      }
      await this.setDefaultLanguages()
      if (this.$cookie.get('currency')) {
        await this.$store.dispatch('settings/operationSetting', this.$cookie.get('currency'))
      }
      if (this.$cookie.get('token')) {
        this.initSocketTheme(globalVar.themes.theme3.value)
        await this.$store.dispatch('themes/player-bank/getBankPlayerAccount')
      }
      await this.$store.commit('settings/changeLanguageLoading', false)
      this.$cookie.remove('is_change_language')

      // To set mission basic setting
      // Since the /activities page onMounted also fire this API
      // By handling in the layout layer is to prevent duplicate API fires
      if (this.$route.path !== '/activities')
        this.$store.dispatch('activities/mission-reward/getMissionSettings', {
          currency: this.$store.state.settings.defaultCurrency
        })
      // To fetch VIP Privilege info
      this.$store.dispatch('activities/vip-system/getVipTiers', {
        currency: this.$store.state.settings.defaultCurrency
      })
      this.$store.dispatch('activities/vip-system/getVipSettings', {
        currency: this.$store.state.settings.defaultCurrency
      })
      if (this.$cookie.get('token')) {
        // Get all missions badges (Badges number)
        this.$store.dispatch('activities/mission-reward/getMissionBadge')
        // Get all notifications
        this.$store.dispatch('activities/notification/getNotifications')
        this.$store.dispatch('themes/player/getMessageNotificationBadges')
      }

      // Check playerMessage
      this.$store.subscribeAction((mutation, state) => {
        if (mutation.type === 'sockets/playerMessage') {
          this.$store.dispatch('themes/player/getMessageNotificationBadges')
          if (this.$route.path === '/player/messages') {
            this.$store.dispatch('themes/player/getMessage')
          }
        }
      })
    },
    methods: {
      onResize() {
        if (process.browser) {
          const MOBILE_SCREEN_WIDTH = 1300
          this.isMobileScreen = window.innerWidth < MOBILE_SCREEN_WIDTH
          this.$store.commit('themes/settings/setIsMobile', this.isMobileScreen)
          return null
        }
        this.isMobileScreen = false
        this.$store.commit('themes/settings/setIsMobile', this.isMobileScreen)
      },
      closeHoldBalanceDialog() {
        this.$store.commit('sockets/setShowHoldBalance', false)
      }
    }
  }
